var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { attrs: { "page-name": "index" } }, [
    _c("div", { staticClass: "index" }, [_vm._v("Please select a menu")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }